import { ProductType } from '@/shared/enums';
import { Episodes, Vods } from '@/shared/libs/sdk';
import { VideoType } from '@/shared/libs/player';

const getResourceAndVideoType = ({ resourceType, liveManager }) => {
  let resource;
  let videoType;

  switch (resourceType) {
    case ProductType.EPISODE:
      resource = new Episodes();
      videoType = VideoType.MOVIE;
      break;
    case ProductType.LIVE:
      resource = liveManager.channels;
      videoType = VideoType.LIVE;
      break;
    case ProductType.PROGRAMME:
      resource = liveManager.programs;
      videoType = VideoType.CATCHUP;
      break;
    case ProductType.VOD:
    case ProductType.CLIP:
      resource = new Vods();
      videoType = VideoType.MOVIE;
      break;
    default:
      break;
  }

  return { resource, videoType };
};

const fetchPlayerProduct = ({
  type,
  id,
  articleType,
  articleId,
  liveManager,
}) => {
  const resourceId = articleId || id;
  const resourceType = (articleType || type).toUpperCase();
  const { resource, videoType } = getResourceAndVideoType({ resourceType, liveManager });

  if (!resource) {
    return Promise.reject();
  }

  return resource.fetch(resourceId)
    .then(() => {
      const product = resource.get(resourceId);
      return { product, videoType };
    });
};

export default fetchPlayerProduct;
